import * as e from 'react';
import { forwardRef, memo } from 'react';

var i=({title:r,titleId:o,...t},l)=>e.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 16 16",fill:"currentColor",ref:l,"aria-labelledby":o,...t},r?e.createElement("title",{id:o},r):null,e.createElement("path",{d:"M15 8A7 7 0 0 1 1 8h1.08A5.92 5.92 0 1 0 8 2.08V1a7 7 0 0 1 7 7"})),n=forwardRef(i),f=memo(n),V=f;

export { V as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-HSW3CTFO.mjs.map